/* Swiper résolu via import map (cf. index.html).
   Les CSS Swiper sont chargées via <link> dans <head> (pas d'import CSS en JS sans bundler). */
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {

  const mobileBreakpoint = 768;

  function initMobileSwiper(selector, options) {
    let swiper = null;

    const enableSwiper = () => {
      if (window.innerWidth <= mobileBreakpoint && !swiper) {
        swiper = new Swiper(selector, options);
      } else if (window.innerWidth > mobileBreakpoint && swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    };

    enableSwiper();

    window.addEventListener('resize', enableSwiper);
  }

  /* ─────────────────────────────
     PACK — slidesPerView responsive, sans loop.
     `watchOverflow` masque automatiquement la navigation
     (classes .swiper-button-lock) quand le contenu tient
     intégralement dans le viewport. Les boutons reçoivent
     .swiper-button-disabled au début/à la fin du slider.
  ───────────────────────────── */
  new Swiper('.pack-swiper', {
    modules: [Navigation],
    spaceBetween: 16,
    slidesPerView: 1,
    slidesPerGroup: 1,
    // speed: 500,
    watchOverflow: true,
    allowTouchMove: true,
    observer: true,
    observeParents: true,
    navigation: {
      prevEl: '.pack__prev',
      nextEl: '.pack__next',
    },
    breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 16,
    },

    1024: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 16,
    },

    1400: {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 16,
    }
  }
  });

  /* ─────────────────────────────
     REVIEWS
  ───────────────────────────── */
  new Swiper('.reviews-swiper', {
    modules: [Navigation, Pagination],
    loop: true,
    spaceBetween: 8,
    slidesPerView: 1,
    navigation: {
      prevEl: '.reviews__prev',
      nextEl: '.reviews__next',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  });

  /* ─────────────────────────────
     REASSURANCE (mobile only)
  ───────────────────────────── */
  initMobileSwiper('.reassurance-swiper', {
    modules: [Pagination],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 8,
    pagination: {
      el: '.reassurance__dots',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
    },
  });

  /* ─────────────────────────────
     OFFERS (mobile only)
  ───────────────────────────── */
  initMobileSwiper('.offers-swiper', {
    modules: [Navigation],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 8,
    navigation: {
      prevEl: '.offers__prev',
      nextEl: '.offers__next',
    },
  });

  /* ─────────────────────────────
     TRUSTPILOT (mobile only)
  ───────────────────────────── */
  initMobileSwiper('.trustpilot-swiper', {
    modules: [Pagination],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 8,
    pagination: {
      el: '.trustpilot-bar__dots',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
    },
  });

});